import Link from 'next/link'

// 公开页面统一页脚:站点地图式的内链 + 公司信息(NAP)。
// 全是真链接,给搜索引擎和 AI 抓取一个稳定的全站入口。
const GROUPS: { title: string; links: [string, string][] }[] = [
  {
    title: '赛事项目',
    links: [
      ['掼蛋比赛编排', '/sports/guandan'],
      ['桥牌复式赛', '/sports/bridge'],
      ['匹克球赛事', '/sports/pickleball'],
      ['网球 / 羽毛球 / 乒乓球', '/sports/racquet'],
      ['升级 / 双扣 / 斗地主', '/sports/shengji'],
    ],
  },
  {
    title: '办赛指南',
    links: [
      ['掼蛋规则入门', '/guide/guandan-rules'],
      ['瑞士制编排规则', '/guide/swiss-system'],
      ['团团转赛制', '/guide/tuantuanzhuan'],
      ['复式赛怎么办', '/guide/duplicate'],
      ['小组循环 + 淘汰赛', '/guide/group-knockout'],
      ['全部指南', '/guide'],
    ],
  },
  {
    title: '内容',
    links: [
      ['资讯', '/news'],
      ['赛事库', '/events'],
      ['规则库', '/rules'],
      ['赛制一览', '/rules/formats'],
      ['灵缇百科', '/baike'],
      ['公开反馈', '/feedback/public'],
    ],
  },
  {
    title: '产品',
    links: [
      ['比赛列表 / 创建比赛', '/match'],
      ['复式发牌机', '/fushiji'],
      ['发牌机常见问题', '/fushiji/faq'],
      ['使用手册', '/manual'],
      ['企业 / 俱乐部教程', '/manual/club'],
      ['APP 下载', '/downloads'],
    ],
  },
  {
    title: '关于',
    links: [
      ['关于灵缇互娱', '/about_us'],
      ['联系我们', '/contact'],
      ['RSS 订阅', '/rss.xml'],
      ['站点地图', '/sitemap.xml'],
    ],
  },
]

const SiteFooter = () => (
  <footer className="bg-ink px-4 py-10 text-sm text-gray-300">
    <div className="mx-auto flex max-w-6xl flex-col gap-8">
      <div className="grid grid-cols-2 gap-6 md:grid-cols-5">
        {GROUPS.map((g) => (
          <div key={g.title} className="flex flex-col gap-2">
            <div className="font-semibold text-white">{g.title}</div>
            {g.links.map(([label, href]) =>
              // .xml 是直出的原始响应,不能走客户端路由
              href.endsWith('.xml') ? (
                <a key={href} href={href} className="text-gray-300 hover:text-white">
                  {label}
                </a>
              ) : (
                <Link key={href} href={href} className="text-gray-300 hover:text-white">
                  {label}
                </Link>
              )
            )}
          </div>
        ))}
      </div>
      <div className="flex flex-col gap-1 border-t border-solid border-white/10 pt-6 text-xs text-gray-400">
        <p>
          灵缇赛事系统(hy.lingti.com)是灵缇互娱旗下的赛事编排与计分平台,支持掼蛋、桥牌、升级、斗地主等棋牌赛事与匹克球、网球、羽毛球、乒乓球等球拍类赛事,由苏州瑞立思科技有限公司研发。
        </p>
        <p>
          电话 <a href="tel:0512-65782012" className="text-gray-300">0512-65782012</a> · 商务合作{' '}
          <a href="tel:15370036553" className="text-gray-300">15370036553</a> · 微信 lingtij · 技术中心:苏州工业园区通园路699号港华大厦708室
        </p>
        <p>
          © 苏州瑞立思科技有限公司 ·{' '}
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer" className="text-gray-400">
            苏ICP备19037090号-7
          </a>
        </p>
      </div>
    </div>
  </footer>
)

export default SiteFooter
